import { NSARouterMakerResult } from 'namirasoft-account-react';
import { FilterItem, FilterItemOperator, IStorageLocal } from 'namirasoft-core';
import { InvoiceCostRow, InvoiceFullRow, InvoiceItemRow, PaymentRow } from 'namirasoft-payment';
import { NamirasoftMap } from 'namirasoft-site-map';
import { BaseColumnFormatter, IDFormatter, IntegerFormatter, MoneyFormatter, NSButtonBlue, NSColumn, NSSpace, NSSpaceSizeType, NSTable, NSTitle, StringFormatter, StringFormatterSizeType } from 'namirasoft-site-react';
import { useState } from 'react';
import { PaymentEntities } from '../PaymentEntities';
import { PaymentLayout } from '../PaymentLayout';
import { PaymentProps } from '../PaymentProps';
import { PaymentRoutes } from '../PaymentRoutes';
import NSPPayDetail from '../components/NSPPayDetail';

export interface InvoiceViewPageProps extends NSARouterMakerResult, PaymentProps { }

export interface InvoiceViewPageState
{
	payments: { rows: PaymentRow[]; count: number; } | null;
}

function InvoiceViewPage(props: InvoiceViewPageProps)
{
	let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);
	const [state, setState] = useState<InvoiceViewPageState>({ payments: null });

	const loadPayments = (invoice_id: string) =>
	{
		let filter = new FilterItem(
			namirasoft.payment.tables.payment,
			namirasoft.payment.tables.payment.columns.invoice_id,
			false,
			FilterItemOperator.all.equals,
			invoice_id
		)

		props.servers.payment.payment.List([filter], null, null, [], null)
			.then((response) => setState((prev) => ({ ...prev, payments: response })))
			.catch(() => { });
	}

	return (
		<PaymentLayout
			{...props}
			action={{
				description: 'View detailed information about each invoice and make your payment.',
			}}
			pages={{
				entity: PaymentEntities.Invoice(props),
				view: {
					ui: {
						getChildrenAfter(_, row)
						{
							let e = row as InvoiceFullRow;
							loadPayments(row.id);

							return <>
								<NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
								<NSTitle title='Items' />
								<NSTable<InvoiceItemRow>
									id={row.id}
									name={"InvoiceItem-" + row.id}
									checkbox={false}
									columns={[
										BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_item.columns.sales_item_id, new IDFormatter(namirasoft, new IStorageLocal())),
										BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_item.columns.offer_id, new IDFormatter(namirasoft, new IStorageLocal())),
										BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_item.columns.offer_item_id, new IDFormatter(namirasoft, new IStorageLocal())),
										BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_item.columns.name, new StringFormatter(StringFormatterSizeType.TwoWords)),
										BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_item.columns.quantity, new IntegerFormatter()),
										BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_item.columns.price, new MoneyFormatter()),
										BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_item.columns.total, new MoneyFormatter()),
										BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_item.columns.description, new StringFormatter(StringFormatterSizeType.FullName)),
									]}
									getRows={async () =>
									{
										return { rows: e.invoice_item, count: e.invoice_item.length };
									}}
									getRowKey={e => e.value.id.toString()}
									ui={{ pagination: false }}
                                    classList={["h-auto"]}
								/>
								{
									e.invoice_cost.length > 0 &&
									<>
										<NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
										<NSTitle title='Other Fees' />
										<NSTable<InvoiceCostRow>
											id={row.id}
											name={"InvoiceCost-" + row.id}
											checkbox={false}
											columns={[
												BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_cost.columns.type, new StringFormatter(StringFormatterSizeType.TwoWords)),
												BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_cost.columns.amount, new MoneyFormatter()),
												BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice_cost.columns.description, new StringFormatter(StringFormatterSizeType.Sentence)),
											]}
											getRows={async () =>
											{
												return { rows: e.invoice_cost, count: e.invoice_cost.length };
											}}
											getRowKey={e => e.value.id.toString()}
											ui={{ pagination: false }}
                                            classList={["h-auto"]}
										/>
									</>
								}
								<NSSpace size={NSSpaceSizeType.SMALL} />
								<NSColumn classList={["align-items-center"]}>
									<NSPPayDetail
										{...props}
										payable={e.total_payable}
										disccount={e.total_discount}
										tax={e.total_tax}
										total={e.total}
										paid={e.total_paid}
										balance={e.total_balance}
										currency={e.currency}
									/>
									{
										row.total_balance > 0 &&
										<>
											<NSButtonBlue
												title='Pay'
												onClick={{
													action: () =>
													{
														if (e.id)
															props.url.redirect(PaymentRoutes.InvoiceGateway(e.id, true, ""), []);
													},
													showLoading: false
												}}
												style={{ width: "272px" }}
											/>
										</>
									}
								</NSColumn>
								{
									state.payments && state.payments.rows.length > 0 &&
									<>
										<NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
										<NSTitle title='Payments' />
										<NSTable<PaymentRow>
											id={row.id}
											name={"PaymentList-" + row.id}
											checkbox={false}
											columns={PaymentEntities.Payment(props).client.getColumns()}
											getRows={async () => state.payments!}
											getRowKey={e => e.value.id.toString()}
											ui={{ pagination: false }}
                                            classList={["h-auto"]}
										/>
									</>
								}
							</>
						}
					}
				},
			}}
		>
			<></>
		</PaymentLayout >
	);
}

export default InvoiceViewPage;